<template>
  <CContainer class="mt-3 bg-whitesmoke" fluid>
    <CRow class="mt-2">
      <CCol>
        <CCard class="mt-2">
          <CCardHeader
            color="success"
          >
            <div class="header-text">
              <h5>Profile</h5>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                v-model="emailInput"
                :isValid="emailValidChecking"
                :invalidFeedback="genericWarning"
                label="Email :"
                disabled
                placeholder="Please insert your valid email here"
              />
              <CInput
                v-model="companyInput"
                :isValid="companyValidChecking"
                :invalidFeedback="genericWarning"
                label="Company :"
                placeholder="Please insert your company here"
              />
              <CButton :disabled="disableButtonUpdateProfile" color="primary" @click="updateProfile()">Update Profile Info</CButton>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard>
          <CCardHeader color="danger">
            <div class="header-text">
              <h5>Change Password</h5>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                v-model="currentPassword"
                type="password"
                :isValid="currentValid"                
                label="Current Password :"
                :invalidFeedback="currentWarning"
                @keyup="checkingValid('currentPassword', 'current')"
                placeholder="Please insert your current password"
              />
              <CInput
                v-model="newPassword"
                type="password"
                :isValid="newValid"
                label="New Password :"
                :invalidFeedback="newWarning"
                @keyup="checkingValid('newPassword', 'new')"
                placeholder="Please insert a new password"
              />
              <CInput
                v-model="newPasswordRetype"
                type="password"
                :isValid="retypeValid"
                label="Retype New Password :"
                :invalidFeedback="retypeWarning"
                @keyup="checkingRetype()"
                placeholder="Please retype your new password"
              />
              <CButton :disabled="disableButtonUpdatePassword" color="primary" @click="updatePassword">Update Password</CButton>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'Profile',
  data(){
    return {
      emailInput: '',
      companyInput: '',
      currentPassword: '',
      newPassword: '',
      newPasswordRetype: '',
      showErrorModal: false,
      modalTitle: 'Error!',
      errorLabel: 'System error occured.',
      currentValid: false,
      newValid: false,
      retypeValid: false,
      currentWarning: '',
      newWarning: '',
      retypeWarning: '',
      genericWarning: 'The field must be filled'
    }
  },
  methods: {
    updateProfile(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/profile';
      this.$axios.put(processUrl, { email: this.emailInput, company: this.companyInput})
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            let statusRefreshData = await this.getProfile();
            if(statusRefreshData){
              this.modalTitle = 'Request Success';
              this.errorLabel = response.data.message;
              this.$store.commit('set', ['isLoading', false]);
              this.showErrorModal = true;
            }
          } else {
            this.modalTitle = 'Failed Update Profile';
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    resetPassword(){
      this.currentPassword = '';
      this.newPassword = '';
      this.newPasswordRetype = '';
    },
    updatePassword(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/change_password';
      this.$axios.post(processUrl, { current_password: this.currentPassword, new_password: this.newPassword})
      .then(async (response) => {
        if(response.status == 200){
          if(response.data.success){
            this.modalTitle = 'Request Success';
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.resetPassword();
            this.showErrorModal = true;
          } else {
            this.modalTitle = 'Failed Update Password';
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    getProfile(){
      this.$store.commit('set', ['isLoading', true]);
      let processUrl = 'api/backend/v2/profile';
      return this.$axios.get(processUrl)
      .then((response) => {
        if(response.status == 200){
          if(response.data.success){
            this.emailInput = response.data.data.email;
            this.companyInput = response.data.data.company;
            this.$store.commit('set', ['isLoading', false]);
            return true;
          } else {
            this.errorLabel = response.data.message;
            this.$store.commit('set', ['isLoading', false]);
            this.showErrorModal = true;
            return false;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    checkingValid(inputCheck, validCheck){
      if(this[inputCheck].length == 0){
        this[validCheck+'Warning'] = 'The field must be filled';
        this[validCheck+'Valid'] = false;
      } else if(this[inputCheck].length > 0 && this[inputCheck].length <= 6) {
        this[validCheck+'Warning'] = 'Password harus lebih dari 6 karakter';
        this[validCheck+'Valid'] = false;
      } else {
        this[validCheck+'Valid'] = true;
      }
    },
    checkingRetype(){
      if(this.newPasswordRetype.length == 0){
        this.retypeWarning = this.genericWarning;
        this.retypeValid = false;
      } else {
        if(this.newPasswordRetype != this.newPassword){
          this.retypeWarning = "Didn't match";
          this.retypeValid = false;
        } else {
          this.retypeValid = true;
        }
      }
    },
    invalidCurrentPasswordWarning(){
      if(this.currentPasswordValidChecking == false){
        this.currentWarning = "this current password not allowed empty";
        return this.currentWarning;
      }
    },
    invalidNewPasswordWarning(){
      if(this.newPasswordValidChecking == false){
        this.newWarning = "this new password not allowed empty";
        return this.newWarning;
      }
    },    
    invalidNewPasswordRetypeWarning(){
      if(this.newPasswordRetypeValidChecking == false){
        this.retypeWarning = "Didn't match";        
        return this.retypeWarning;
      }
    },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    }
  },
  computed: {
    companyValidChecking(){
      if(this.companyInput.length > 0){
        return true;
      } else { return false }
    },
    emailValidChecking(){
      if(this.emailInput.length > 0){
        return true;
      } else { return false }
    },
    disableButtonUpdateProfile(){
      if(this.emailValidChecking == false || this.companyValidChecking == false){
        return true;
      } else { return false }
    },    
    disableButtonUpdatePassword(){
      if((this.currentValid == false || this.newValid == false || this.retypeValid == false)){
        return true;
      } else {return false}
    }
  },
  async created(){
    await this.getProfile();
  }
}
</script>

<style>

</style>